@if (freeBetToken) {
    <bs-freebet-stake [freeBetToken]="freeBetToken" />
} @else {
    <ms-stake
        [stake]="stakeAsStr"
        [errors]="hasStakeError$"
        [keypadId]="keypadId"
        [numpadSource]="numpadSource"
        [disabled]="isDisabled"
        [bsLinearStakeScroll]="'.betslip-edit-state__scroller'"
        (stakeChanged)="setStake($event)" />
}
